import React, { useEffect, useState, useContext } from 'react';
import GroupAPI from 'api/GroupAPI';
import { GlobalContext } from 'providers/GlobalProvider';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';
import { userJoinedNotification } from '../../utils/NotificationsFuncs';
import UsersAPI from 'api/UsersAPI';
import { Button } from '@mui/material';

const JoinTeamFromInvite: React.FC = (props: any) => {
  const [ teamToJoin, setTeamToJoin ] = useState<any>({});
  const { cur_user } = useContext(GlobalContext);
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const getTeam = async() => {
    const res = await GroupAPI.getGroupById(props.match.params.id);
    if (res?.success) {
      setTeamToJoin(res.result);
    }
  };

  const joinTeam = async() => {
    if (cur_user?.basics?.id && teamToJoin?.attributes?.pending && teamToJoin?.attributes?.pending?.includes(cur_user?.basics?.email)) {
      const res = await GroupAPI.assignGroupToUser(teamToJoin.id, cur_user.basics.id);
      if (res?.success) {
        await GroupAPI.removePendingInvite({ group_id: teamToJoin.id, email: cur_user.basics.id });

        const resp = await UsersAPI.searchUsers(teamToJoin.attributes.team_admin[0]);
        if (resp?.success) {
          const adminId = resp.result[0].id;
          await userJoinedNotification(cur_user, teamToJoin, adminId);
          enqueueSnackbar('Joined team successfully', { variant: 'success' });
          history.push('/');
          history.go(0);
        } else {
          enqueueSnackbar('Error Notifying Group Admin', { variant: 'error' });
        }
      } else {
        enqueueSnackbar('Error joining team. Please try again or contact us if this issue persists', { variant: 'error' });
      }
    }
  };

  useEffect(() => {
    getTeam();
  }, []);

  return (
    <div className='join-team-container'>
      <div className='join-team-content'>
        <h1>Team Name</h1>
        <h2>{teamToJoin?.name}</h2>
        <h3>Team Admin</h3>
        <h4>{teamToJoin?.attributes?.team_admin[0]}</h4>
        <h5>Once you join the team your team admin may assign you a license to access the features within BITE</h5>
      </div>
      <div className='register-btns-container'>
        <Button
          onClick={() => joinTeam()}
          className='note-link-btn'
        >
          Join Team
        </Button>
      </div>
    </div>
  );
};

export default JoinTeamFromInvite;
